<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">
  </form-wrapper>
</template>

<script>
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {};
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  methods: {
    submit: function() {
      this.$emit("submitted");
    },
    previous: function() {
      this.$emit("previous");
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
